import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'squareMeter'  // Perbaiki nama (sebelumnya 'sequareMeter')
})
export class SquareMeterPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '0 m²';
    }

    // Konversi value ke number jika belum
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    // Jika bukan angka yang valid, kembalikan 0
    if (isNaN(numValue)) {
      return '0 m²';
    }

    // Format angka dengan pemisah ribuan (titik)
    const formattedValue = numValue.toLocaleString('id-ID');

    // Tambahkan simbol meter persegi
    return `${formattedValue} m²`;
  }
}
